import FilterBar from './components/FilterBar';

export default FilterBar;